import { ICheckoutData } from '../../checkoutEnergy.models';
import TaggingOtpCard from './otpCard.tagging';

const OtpCard = ({ handleOnChangeEnableGoNext, handleGoPrevSlide }: ICheckoutData) => {
  return (
    <>
      <TaggingOtpCard />
    </>
  );
};

export default OtpCard;
